import { render, staticRenderFns } from "./ImprovementTab.vue?vue&type=template&id=954983dc&scoped=true"
import script from "./ImprovementTab.vue?vue&type=script&lang=js"
export * from "./ImprovementTab.vue?vue&type=script&lang=js"
import style0 from "./ImprovementTab.vue?vue&type=style&index=0&id=954983dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954983dc",
  null
  
)

export default component.exports